import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  tableFooter: {
    display: "grid",
    gridTemplateColumns: "290px 1410px",
    backgroundColor: "#fff",
    position: "fixed",
    bottom: 0,
    boxShadow: "0px -2px 7px 0px rgba(0, 0, 0, 0.15)",
    zIndex: 2
  },
  lightGreenCells: {
    backgroundColor: "#e7fff5"
  },
  mediumGreenCells: {
    backgroundColor: "#e2f9ef"
  }
});
